/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_UsInputs */

const en_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const es_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const fr_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const de_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const ja_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const zh_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美码 (US)`)
};

const ar_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أمريكي (US)`)
};

const id_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AS`)
};

const it_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const ru_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const pt_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US`)
};

const ko_val_us = /** @type {(inputs: Val_UsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US (미국 사이즈)`)
};

/**
* | output |
* | --- |
* | "US" |
*
* @param {Val_UsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_us = /** @type {((inputs?: Val_UsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_UsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_us(inputs)
	if (locale === "es") return es_val_us(inputs)
	if (locale === "fr") return fr_val_us(inputs)
	if (locale === "de") return de_val_us(inputs)
	if (locale === "ja") return ja_val_us(inputs)
	if (locale === "zh") return zh_val_us(inputs)
	if (locale === "ar") return ar_val_us(inputs)
	if (locale === "id") return id_val_us(inputs)
	if (locale === "it") return it_val_us(inputs)
	if (locale === "ru") return ru_val_us(inputs)
	if (locale === "pt") return pt_val_us(inputs)
	return ko_val_us(inputs)
});